if (!customElements.get('gift-upsell')) {
  class GiftUpsell extends HTMLElement {
    connectedCallback() {
      const total     = parseInt(this.dataset.cartTotal, 10);
      const threshold = parseInt(this.dataset.threshold, 10);
      const remainingText = this.querySelector('.gift-upsell__text-remaining');
      const fullText      = this.querySelector('.gift-upsell__text-full');
      const amountSpan    = this.querySelector('.gift-upsell__text-remaining span');

      let percentage;
      if (total < threshold) {
        percentage = total / threshold;
        const remaining = threshold - total;
        const format = (window.theme && window.theme.settings.money_with_currency_format) || 'kr. {{amount}}';
        if (amountSpan) amountSpan.innerHTML = formatMoney(remaining, format);
        remainingText.style.display = 'block';
        fullText.style.display = 'none';
      } else {
        percentage = 1;
        remainingText.style.display = 'none';
        fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }
  customElements.define('gift-upsell', GiftUpsell);
}
